import { ReactNode } from 'react';
import { BaseEventStyleKey } from '@features/components/ClinicalData/components/ClinicalLog/components/constants';
import { LogTypeKeys } from '@features/components/ClinicalData/components/ClinicalLog/types';
import { useAppContext } from '@features/contexts/AppProvider';
import { cn } from '@ds';
import { LogItemHeader } from './LogItemHeader';

export type BaseEventProps = {
  onShareClick?: () => void;
  shared?: boolean;
  event: string;
  description?: string;
  endContent?: ReactNode;
  headerSharedVariant?: 'base' | 'light';
  descriptionCss?: string;
};

const cssStyles = {
  [BaseEventStyleKey.base]: {
    labelClassNames: 'text-s-m',
  },
  [BaseEventStyleKey.medium]: {
    labelClassNames: 'font-medium',
  },
};

export const BaseEvent = ({
  shared,
  event = 'Event',
  description,
  endContent,
  onShareClick,
  headerSharedVariant = 'base',
  descriptionCss = 'text-base-10',
}: BaseEventProps) => {
  const {
    clinicalLog: { styles },
  } = useAppContext();
  const style = cssStyles[styles[LogTypeKeys.BaseEventItem] as BaseEventStyleKey];

  return (
    <div className="flex flex-col gap-1 w-full">
      <LogItemHeader
        onShareClick={onShareClick}
        event={event}
        sharedIndicatorIcon={shared}
        endContent={endContent}
        cssStyleBySize={style}
        sharedVariant={headerSharedVariant}
      />
      {description && (
        <div className={cn('text-m-r! break-all whitespace-pre-line', descriptionCss)}>{description}</div>
      )}
    </div>
  );
};
